import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import Result from '../../_interface/result';
import ResultInt from '../../_interface/result-int';

var NebulaModuleBase = function () {
    function NebulaModuleBase() {
        var _this = this;

        _classCallCheck(this, NebulaModuleBase);

        this.eventListenersMap = new Map();
        this.onContainerEvent = function (event) {
            var eventListeners = _this.eventListenersMap.get(event.type);
            window.console.info('onContainerEvent name ' + event.type, event);
            var data = event === null || event === void 0 ? void 0 : event.data;
            if (eventListeners) {
                window.console.info('onContainerEvent eventListenersMap name ' + event.type + ', size= ' + eventListeners.size);
            } else {
                window.console.info('onContainerEvent eventListenersMap name ' + event.type + ', size =0');
            }
            eventListeners === null || eventListeners === void 0 ? void 0 : eventListeners.forEach(function (listener) {
                window.console.info('onContainerEvent eventListeners callback', data);
                try {
                    listener.call(_this, data);
                } catch (error) {
                    window.console.info('onContainerEvent ' + event.type + ' error', error);
                }
            });
        };
        this.bridge = window && window.AlipayJSBridge;
        // if (!this.bridge) {
        //     throw Error('未正常获得AlipayJSBridge实例');
        // }
    }

    _createClass(NebulaModuleBase, [{
        key: 'generatePromiseByFunctionWithParams',
        value: function generatePromiseByFunctionWithParams(func, param) {
            return new Promise(function (resolve, reject) {
                window.console.info('generate ' + func + ' call ' + JSON.stringify(param));
                window.AlipayJSBridge.call(func, param, function (ret) {
                    window.console.info('bridge.call ' + func + ' ' + JSON.stringify(ret));
                    if ((ret === null || ret === void 0 ? void 0 : ret.retCode) === '000000' || (ret === null || ret === void 0 ? void 0 : ret.retCode) === '00000') {
                        resolve(new Result('000000', '\u8C03\u7528\u51FD\u6570' + func + '\u6210\u529F', ret.retData));
                    } else {
                        reject(new Result(ret === null || ret === void 0 ? void 0 : ret.retCode, '\u8C03\u7528\u51FD\u6570' + func + '\u5931\u8D25,\n          errMsg:' + (ret.retInfo || ret.message), ret.retData || ''));
                    }
                });
            });
        }
        // 区别于generatePromiseByFunctionWithParams方法的地方：返回错误直接透传retInfo

    }, {
        key: 'generatePromiseByFunction',
        value: function generatePromiseByFunction(func, param) {
            return new Promise(function (resolve, reject) {
                window.console.info('generate ' + func + ' call ' + JSON.stringify(param));
                window.AlipayJSBridge.call(func, param, function (ret) {
                    window.console.info('bridge.call ' + func + ' ' + JSON.stringify(ret));
                    if ((ret === null || ret === void 0 ? void 0 : ret.retCode) === '000000' || (ret === null || ret === void 0 ? void 0 : ret.retCode) === '00000') {
                        resolve(new Result('000000', '\u8C03\u7528\u51FD\u6570' + func + '\u6210\u529F', ret.retData));
                    } else {
                        reject(new Result(ret === null || ret === void 0 ? void 0 : ret.retCode, ret.retInfo || ret.message, ret.retData || ''));
                    }
                });
            });
        }
        // 如果缓存集合中已经有相同的eventName，则不会重复调用容器插件方法（需要使用者根据实际的业务情况自定义，如：NodeChange_a/b）；

    }, {
        key: 'generatePromiseByAttachListenerWithParams',
        value: function generatePromiseByAttachListenerWithParams(eventName, listener, func, param) {
            if (typeof listener === 'function') {
                var eventListeners = this.eventListenersMap.get(eventName);
                if (!eventListeners || eventListeners.size === 0) {
                    // 该eventName初次注册事件监听
                    document.addEventListener(eventName, this.onContainerEvent, false);
                    window.console.info(eventName + ' first addEventListener');
                    eventListeners = new Set();
                    eventListeners.add(listener);
                    window.console.info(eventName + ' first add, size= ' + eventListeners.size);
                    this.eventListenersMap.set(eventName, eventListeners);
                    if (func) {
                        return new Promise(function (resolve, reject) {
                            window.AlipayJSBridge.call(func, param, function (ret) {
                                window.console.info('bridge.call ' + func + ' ' + JSON.stringify(ret));
                                if ((ret === null || ret === void 0 ? void 0 : ret.retCode) === '000000' || (ret === null || ret === void 0 ? void 0 : ret.retCode) === '00000') {
                                    resolve(new Result('000000', '\u8C03\u7528\u51FD\u6570' + func + '\u6210\u529F', ret.retData));
                                } else {
                                    // 失败时需把监听移除，防止重复调用时（首次失败），方法执行无法触发
                                    window.console.info(eventName + ' add failed', eventListeners);
                                    eventListeners['delete'](listener);
                                    window.console.info(eventName + ' add failed,remove listener', eventListeners);
                                    reject(new Result(ret === null || ret === void 0 ? void 0 : ret.retCode, '\u8C03\u7528\u51FD\u6570' + func + '\u5931\u8D25,\n                           errMsg:' + (ret.retInfo || ret.message), ret.retData || ''));
                                }
                            });
                        });
                    }
                } else {
                    window.console.info(eventName + ' befor add, size= ' + eventListeners.size);
                    eventListeners.add(listener);
                    window.console.info(eventName + ' after added, size= ' + eventListeners.size);
                }
                return Promise.resolve(new ResultInt('000000', '\u6DFB\u52A0' + eventName + '\u76D1\u542C\u5668\u6210\u529F'));
            } else {
                return Promise.reject(new ResultInt('000001', '\u6DFB\u52A0' + eventName + '\u76D1\u542C\u5668\u5931\u8D25,\u76D1\u542C\u4E0D\u662F\u51FD\u6570'));
            }
        }
    }, {
        key: 'generatePromiseByDetachListenerWithParams',
        value: function generatePromiseByDetachListenerWithParams(eventName, listener, func, param) {
            if (typeof listener === 'function') {
                var eventListeners = this.eventListenersMap.get(eventName);
                if (eventListeners) {
                    var deleteResult = eventListeners['delete'](listener);
                    window.console.info('Detach ' + eventName + ' ,result=' + deleteResult + ', size= ' + eventListeners.size);
                    if (!deleteResult) {
                        return Promise.reject(new ResultInt('000001', '\u76D1\u542C\u56DE\u8C03' + eventName + ' \u4E0D\u5B58\u5728'));
                    }
                    if (eventListeners.size === 0) {
                        this.eventListenersMap['delete'](eventName);
                        window.console.info('Detach ' + eventName + ' eventListenersMap, size= ' + this.eventListenersMap.size);
                        document.removeEventListener(eventName, this.onContainerEvent, false);
                        if (func) {
                            return this.generatePromiseByFunctionWithParams(func, param);
                        }
                    }
                    return Promise.resolve(new ResultInt('000000', '\u79FB\u9664' + eventName + '\u76D1\u542C\u5668\u6210\u529F'));
                } else {
                    return Promise.reject(new ResultInt('000001', '\u79FB\u9664' + eventName + '\u76D1\u542C\u5668\u5931\u8D25,\u76D1\u542C\u4E0D\u5B58\u5728'));
                }
            } else {
                return Promise.reject(new ResultInt('000001', '\u79FB\u9664' + eventName + '\u76D1\u542C\u5668\u5931\u8D25,\u76D1\u542C\u4E0D\u662F\u51FD\u6570'));
            }
        }
    }]);

    return NebulaModuleBase;
}();

export default NebulaModuleBase;